module.exports = __webpack_public_path__ + "static/media/areamap9.c6300c9e.svg";